import React, { useState } from "react";
import IconWithText from "../../iconWithText";
import "./style.css";
import { EnglishIcon, KSA, Phone, whatsApp } from "../../../assets/svgIcons";
import UseGeneral from "../../../hooks/useGeneral";
import PopUp from "../../popup";
import { useSelector } from "react-redux";
const LeftMiddleHeader = ({ whats, phone }) => {
  const { language, changeLanguage, data } = UseGeneral();
  const siteData = useSelector((state) => state?.site?.siteData);
  const [open, setOpen] = useState(false);
  return (
    <div
      className="LeftMiddleHeader"
      style={
        language == "ar" ? { marginRight: "auto" } : { marginLeft: "auto" }
      }
    >
      <IconWithText
        icon={Phone}
        text={language == "ar" ? "تواصل معنا" : "Contact Us"}
        onClick={() => setOpen(true)}
      />
      <PopUp
        open={open}
        setOpen={setOpen}
        title={language == "ar" ? "تواصل معنا" : "Contact Us"}
      >
        <div className="rowDiv">
          <IconWithText
            onClick={() => window.open("tel:" + siteData?.mobile, "_blanck")}
            icon={Phone}
            text={language == "ar" ? "الخط الساخن" : "Hot Line"}
            className={"contact"}
          />
        </div>
        <div className="rowDiv">
          <IconWithText
            onClick={() =>
              window.open(
                "https://wa.me/" + siteData?.whats_number,
                "_blanck"
              )
            }
            icon={whatsApp}
            text={language == "ar" ? "واتساب" : "WhatsApp"}
            className={"contact"}
          />
        </div>
      </PopUp>
      {language?.toLowerCase() == "ar" ? (
        <IconWithText
          icon={EnglishIcon}
          reverse={true}
          pointer={true}
          text={"EN"}
          onClick={() => changeLanguage("en")}
        />
      ) : (
        <IconWithText
          icon={KSA}
          reverse={true}
          pointer={true}
          text={"العربية"}
          onClick={() => changeLanguage("ar")}
        />
      )}
    </div>
  );
};

export default LeftMiddleHeader;
